import React from 'react';

import { Stack, Text } from '@mantine/core';

interface IDetailFieldProps {
  label: string;
  children: React.ReactNode;
}

const DetailField = ({ label, children }: IDetailFieldProps): JSX.Element => {
  return (
    <Stack spacing={0}>
      <Text size='md' weight='bold' color='dimmed'>
        {label}
      </Text>
      <Text size='sm' color='dimmed'>
        {children}
      </Text>
    </Stack>
  );
};

export default DetailField;
